// Verrechnung (README §6 Regel 3): Zahlungen tilgen immer den ältesten offenen Posten.
// Ein Überschuss bleibt als Guthaben stehen.

import { runde } from './datum';
import type { Buchung, SollPosten } from './typen';

export interface VerrechnungsErgebnis {
  /** bezahlter Anteil je Posten (gleiche Reihenfolge wie die nach Fälligkeit sortierten Posten) */
  posten: (SollPosten & { bezahlt: number })[];
  sollSumme: number;
  /** Summe aller gültigen Zahlungen */
  istSumme: number;
  /** nicht verbrauchter Rest der Zahlungen */
  guthaben: number;
  /** Fälligkeit des ältesten nicht voll bezahlten Postens */
  offenSeit: string | null;
}

export function verrechne(soll: readonly SollPosten[], buchungen: readonly Pick<Buchung, 'betrag' | 'storniert'>[]): VerrechnungsErgebnis {
  const posten = [...soll].sort((a, b) => a.faellig.localeCompare(b.faellig)).map(p => ({ ...p, bezahlt: 0 }));
  // Negative Posten (Guthaben aus dem Anfangssaldo) wirken wie eine Zahlung.
  let topf = buchungen.filter(b => !b.storniert && b.betrag > 0).reduce((s, b) => s + b.betrag, 0);
  const istSumme = runde(topf);
  topf += posten.filter(p => p.betrag < 0).reduce((s, p) => s - p.betrag, 0);

  for (const p of posten) {
    if (p.betrag <= 0 || topf <= 0) continue;
    const t = Math.min(p.betrag, topf);
    p.bezahlt = runde(t);
    topf = runde(topf - t);
  }
  const offen = posten.find(p => p.betrag > 0 && p.bezahlt < p.betrag - 0.005);
  return {
    posten,
    sollSumme: runde(soll.reduce((s, p) => s + p.betrag, 0)),
    istSumme,
    guthaben: runde(Math.max(0, topf)),
    offenSeit: offen ? offen.faellig : null,
  };
}
